import type { GetIndicatorResultAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetIndicatorResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetIndicatorResultAuditByIdArgs = {
  id: string;
};

export const useGetIndicatorResultAuditById = createQueryHook<
  UseGetIndicatorResultAuditByIdArgs,
  GetIndicatorResultAuditByIdResponseRow[],
  AuditLogQueryResult<
    'indicator_result_audit',
    GetIndicatorResultAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIndicatorResultAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_result_audit: data }),
  graphqlDocument: GetIndicatorResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
